module.exports = __webpack_public_path__ + "img/agency_thumbnail.14ac3e74.jpg";